import React from 'react';
import { Card, Space, Typography, Progress, Skeleton, Button, Tooltip } from 'antd';
import { BankOutlined, CheckCircleOutlined, ClockCircleOutlined, CloseCircleOutlined, DownloadOutlined } from '@ant-design/icons';

const { Text } = Typography;

const OpenFinanceStatus = ({ data, loading, onExport }) => {
  const values = data?.datasets?.[0]?.data || [0, 0, 0];
  const total = values.reduce((a, b) => a + b, 0);
  const labels = ['Conectadas', 'Expiradas', 'Sem Adesão'];
  const colors = ['#10b981', '#f59e0b', '#ef4444'];
  const icons = [
    <CheckCircleOutlined style={{ fontSize: 16 }} />,
    <ClockCircleOutlined style={{ fontSize: 16 }} />,
    <CloseCircleOutlined style={{ fontSize: 16 }} />
  ];

  const getPercentage = (value) => total > 0 ? Math.round((value / total) * 100) : 0;

  return (
    <Card
      title={
        <Space size={12}>
          <div style={{ background: '#f8fafc', padding: 8, borderRadius: 12, display: 'flex' }}>
            <BankOutlined style={{ color: '#64748b', fontSize: 20 }} />
          </div>
          <div>
            <div style={{ fontWeight: 800, fontSize: 16, lineHeight: 1.2 }}>Adesão Open Finance</div>
            <div style={{ fontSize: 12, color: '#94a3b8', fontWeight: 400 }}>Status de conexão bancária</div>
          </div>
        </Space>
      }
      extra={
        onExport && (
          <Tooltip title="Exportar dados Open Finance">
            <Button 
              type="text" 
              icon={<DownloadOutlined style={{ fontSize: 16 }} />} 
              onClick={onExport}
              style={{ color: '#64748b' }}
            />
          </Tooltip>
        )
      }
      bordered={false}
      style={{ borderRadius: 24, boxShadow: '0 10px 40px rgba(0,0,0,0.04)' }}
    >
      {loading ? (
        <Skeleton active paragraph={{ rows: 6 }} />
      ) : (
        <div style={{ padding: '10px 0' }}>
          <div style={{ marginBottom: 30, textAlign: 'center' }}>
            <div style={{ fontSize: 11, color: '#94a3b8', fontWeight: 800, letterSpacing: 1 }}>TOTAL DE CLIENTES</div>
            <div style={{ fontSize: 44, fontWeight: 900, color: '#0f172a' }}>{total.toLocaleString()}</div>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 20, paddingBottom: 10 }}>
            {labels.map((label, index) => {
              const pct = getPercentage(values[index]);
              return (
                <div key={index}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 8, alignItems: 'center' }}>
                    <Space size={10}>
                      <div style={{ color: colors[index], display: 'flex' }}>{icons[index]}</div>
                      <Text strong style={{ fontSize: 13, color: '#334155' }}>{label}</Text>
                    </Space>
                    <Space size={12}>
                      <Text style={{ fontSize: 13, color: '#64748b' }}>{values[index]} Clientes</Text>
                      <Text strong style={{ fontSize: 13, color: '#0f172a' }}>{pct}%</Text>
                    </Space>
                  </div>
                  <Progress
                    percent={pct}
                    showInfo={false}
                    strokeColor={colors[index]}
                    strokeWidth={12}
                    style={{ margin: 0 }}
                  />
                </div>
              );
            })}
          </div>
        </div>
      )}
    </Card>
  );
};

export default OpenFinanceStatus;

